export function shouldSubmitOnEnter(event) {
  if (event.key !== "Enter" || event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
    return false;
  }
  if (event.nativeEvent?.isComposing) {
    return false;
  }
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return true;
  }

  const userAgent = navigator.userAgent || "";
  const mobileUserAgent = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(userAgent);
  const coarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
  const smallTouchScreen = Boolean(coarsePointer && window.innerWidth <= 900);

  return !(mobileUserAgent || smallTouchScreen);
}
